import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./index.module.scss";
import { useState } from "react";
export const SwitchBarForLogin = props => {
  const {
    config,
    checkoutFunc,
    style
  } = props;
  const [currentKey, setCurrentKey] = useState(config[0].key);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.switch_container,
    style: style,
    children: [config.map((item, index) => {
      return /*#__PURE__*/_jsx("div", {
        className: classNames({
          [styles.switch_item]: true,
          [styles.active]: currentKey == item.key
        }),
        onClick: () => {
          checkoutFunc(item.key);
          setCurrentKey(item.key);
        },
        children: item.name
      }, index);
    }), /*#__PURE__*/_jsx("div", {
      className: classNames({
        [styles.boxSlider]: true,
        [styles.active]: currentKey == config[1].key
      }),
      children: /*#__PURE__*/_jsx("div", {
        className: styles.innerBox
      })
    })]
  });
};